import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import {
  MemberItem,
  MemberLink,
  MemberLinks,
  MemberShadow,
  MemberName,
} from './styles';

const Member: React.FC<IMember> = ({
  userName,
  urlHTML,
  urlAvatar,
  urlLinkedin,
}: IMember) => (
  <MemberItem>
    <img
      width="100%"
      height="100%"
      src={urlAvatar}
      alt={`member profile ${userName}`}
    />

    <MemberShadow>
      <MemberName>
        {userName.length > 20
          ? `${userName.split(' ')[0]} ${userName.split(' ')[1]}`
          : userName}
      </MemberName>

      <MemberLinks>
        <MemberLink target="_new" href={urlHTML}>
          <FontAwesomeIcon size={'1x'} icon={faGithub} />
        </MemberLink>

        {urlLinkedin ? (
          <MemberLink target="_new" href={urlLinkedin}>
            <FontAwesomeIcon size={'1x'} icon={faLinkedinIn} />
          </MemberLink>
        ) : (
          <></>
        )}
      </MemberLinks>
    </MemberShadow>
  </MemberItem>
);

export default Member;
